import NotInformation from "../../../../../../components/NotInformation";
import React from "react";
import { CustomFieldCardStyle } from "../../../../../../components/Styles";
import {EMPTY_VALUES, formatBytes, getValueFromData} from "../../../../../../Apis/functions";
import {FIELD_TYPE, sortListFieldType} from "../../../Type/Model/Model";
import {CustomCheckbox} from "../../../../../../components/CustomCheckbox";
import {FileChip} from "../../../../../../components/buttons/IconButtons";
import {getFileIcon, getFileNameWithoutExtension} from "../../../../../../Helpers/fileType";
import {STATUS_MODEL} from "../../../../../../enums/statusEnum";
import CustomFileCard from '../../../../../../components/CustomFileCard';
/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const DocumentationFormSummary = ({ getInvitationById, data, t, photoPickerList }) => {
    const fields = sortListFieldType(getInvitationById?.fields || []);
    const styles = CustomFieldCardStyle(STATUS_MODEL.PENDING_REVIEW, false);

    return (
        <>
            {fields.length > 0 ? (
                <div className="row background-general-00 box-shadow-primary-900-opacity-10 p-24px border-radius-8px">
                    {
                        fields
                            .filter(field => field.fieldType !== FIELD_TYPE.DOCUMENT.name && field.fieldType !== FIELD_TYPE.CHECKBOX.name)
                            .map(field => {
                                const fieldValue = getValueFromData(field.fieldId, field.fieldType, data);

                                return (<div key={field.fieldId} className="col-12-sm col-lg-6 col-xl-6 gap-2 mt-24px">
                                        <p style={styles.title}>{field.fieldName}</p>
                                        <p className="justify-content-start d-flex ibl-font-w-400 fs-14px">
                                            {fieldValue || EMPTY_VALUES.DEFAULT}
                                        </p>
                                    </div>
                                );
                            })
                    }
                    {
                        fields
                            .filter(field => field.fieldType === FIELD_TYPE.CHECKBOX.name)
                            .map(field => {
                                const fieldValue = getValueFromData(field.fieldId, field.fieldType , data);
                                return (
                                    <div key={field.fieldId} className="col-12 px-0">
                                        <CustomCheckbox
                                            id={`${[field.fieldType]}_${field.fieldId}`}
                                            name= {field.fieldName}
                                            required={field.required}
                                            trans={field.fieldName}
                                            checked={fieldValue === 'true'}
                                            disabled={true}
                                            marginbutton={true}
                                        />
                                    </div>
                                );
                            })
                    }
                    {
                        photoPickerList
                            .map(field => {
                                let fileValue;
                                let fileSize;
                                let Icon;
                                let title;
                                let size;
                                const hasValue = field?.value &&
                                    (field.value?.fileSelected || field.value?.selfieSrc || field.value?.srcSelected || field.value?.previewImage )

                                if(hasValue){
                                    fileValue = field.value?.fileSelected?.name || field.value?.previewImage?.name;
                                    fileSize = fileValue ? (field.value?.fileSelected?.size || field?.size) : 0;
                                    Icon = fileValue?.trim() ? getFileIcon(fileValue) : FileChip;
                                    title = getFileNameWithoutExtension(fileValue);
                                    size = formatBytes(fileSize);
                                }

                                return (
                                    <div key={field?.fieldId} className="col-12-sm col-lg-6 col-xl-6 gap-2 mt-24px">
                                        <p style={styles.title}>{field.fieldName}</p>
                                        { !hasValue ?
                                            EMPTY_VALUES.DEFAULT
                                            :
                                            <CustomFileCard
                                                title={title || EMPTY_VALUES.DEFAULT}
                                                Icon={Icon}
                                                subtitle={size || EMPTY_VALUES.DEFAULT}
                                                showBtnDelete={false}
                                                classes="card-shades-300-50-2px border-radius-8px w-100"
                                            />
                                        }
                                    </div>
                                );
                            })
                    }
                </div>
            ) : (
                <NotInformation card={false} text={t('no_documentation')} />
            )}
        </>
    );
};


export default DocumentationFormSummary
